import {
  CurrentUser,
  LoginResultSessionVM,
  LoginVM,
  Menu,
  RMTCreatedUser,
  UserVM,
  VwLoginReport,
  TwoFactorUser,
  Notification,
  PostNotification,
  NotificationResult,
  ExternalResponse,
  ChangePasswordRequestVM,
  Role,
  SignUpResolve,
  SignUpForm,
  GetUsersParams,
  Doctor
} from '@/models'
import axios, { AxiosResponse } from 'axios'
const API_URL = 'Authentication'
import qs from 'qs' // npm i qs

export const login = async (
  model: LoginVM
): Promise<AxiosResponse<LoginResultSessionVM>> => {
  const response = await axios.post<LoginResultSessionVM>(API_URL, model, {
    // withCredentials: true
  })
  // console.log(response)
  return response
}
export const LoginWithOtp = async (
  model: LoginVM
): Promise<AxiosResponse<LoginResultSessionVM>> => {
  const response = await axios.post<LoginResultSessionVM>(API_URL, model)
  // console.log(googleToken)
  return response
}
export const loginWithGoogle = async (
  ExternalResponse: ExternalResponse
): Promise<AxiosResponse<LoginResultSessionVM>> => {
  const response = await axios.post<LoginResultSessionVM>(
    API_URL + '/GoogleSignIn',
    ExternalResponse
  )
  // console.log(googleToken)
  return response
}
export const changePassword = async (
  ChangePasswordRequestVM: ChangePasswordRequestVM
): Promise<AxiosResponse<LoginResultSessionVM>> => {
  const response = await axios.post<LoginResultSessionVM>(
    API_URL + '/ChangePassword',
    ChangePasswordRequestVM
  )
  // console.log(googleToken)
  return response
}

export const isAuthenticated = (): boolean => {
  let isAuth = false
  if (localStorage.getItem('currentUser') != null) {
    isAuth = true
  } else {
    isAuth = false
  }
  return isAuth
}
// export const getUsers = async (
//   params: GetUsersParams
// ): Promise<AxiosResponse<RMTCreatedUser[]>> => {
//   return axios.get<RMTCreatedUser[]>('Users', {
//     params: {
//       pageNumber: params.pageNumber ?? 1,
//       pageSize: params.pageSize ?? 10,
//       SearchQuery: params.searchQuery?.trim() || undefined,
//       RoleIds:
//         params.roleIds && params.roleIds.length ? params.roleIds : undefined,
//       Active: params.active ?? undefined,
//       TwoFA: params.twoFA ?? undefined
//     },
//     paramsSerializer: p =>
//       qs.stringify(p, { arrayFormat: 'repeat', skipNulls: true })
//   })
// }
// export function getUsers(
//   p: GetUsersParams
// ): Promise<AxiosResponse<RMTCreatedUser[]>> {
//   return axios.get<RMTCreatedUser[]>('/api/users', {
//     params: {
//       pageNumber: p.pageNumber ?? 1,
//       pageSize: p.pageSize ?? 25,
//       SearchQuery: p.searchQuery?.trim() || undefined,
//       SearchFields: p.searchFields || undefined,
//       RoleIds: p.roleIds?.length ? p.roleIds : undefined,
//       ActiveIn: p.activeIn?.length ? p.activeIn : undefined,
//       TwoFAIn: p.twoFAIn?.length ? p.twoFAIn : undefined
//     },
//     paramsSerializer: x =>
//       qs.stringify(x, { arrayFormat: 'repeat', skipNulls: true })
//   })
// }
// export async function getUsers(params: GetUsersParams) {
//   return axios.get('/api/users', {
//     params,
//     paramsSerializer: p =>
//       qs.stringify(p, { arrayFormat: 'repeat', skipNulls: true }),
//   });
// }
export function getUsers(
  p: GetUsersParams
): Promise<AxiosResponse<RMTCreatedUser[]>> {
  const params: any = {
    PageNumber: p.pageNumber ?? 1,
    pageSize: p.pageSize ?? 25,
    SearchQuery: p.searchQuery?.trim() || undefined,
    RoleId: p.roleId ?? undefined,
    Active: p.active ?? undefined,
    TwoFA: p.twoFA ?? undefined,
    DoctorHeadID: p.doctorHeadID ?? undefined
  }

  // 4-state logic
  if (p.policyAcceptance === true) {
    params.PolicyAcceptance = 'true'
  } else if (p.policyAcceptance === false) {
    params.PolicyAcceptance = 'false'
  } else if (p.policyAcceptance === null) {
    params.PolicyAcceptance = 'na' // encode N/A
  } // undefined => don't add param → no filter

  // console.log(params)

  return axios.get<RMTCreatedUser[]>('/users', { params })
}
// export function getUsers(
//   p: GetUsersParams
// ): Promise<AxiosResponse<RMTCreatedUser[]>> {
//   console.log(p)
//   return axios.get<RMTCreatedUser[]>('/users', {
//     params: {
//       pageNumber: p.pageNumber ?? 1,
//       pageSize: p.pageSize ?? 25,
//       SearchQuery: p.searchQuery?.trim() || undefined,
//       RoleId: p.roleId ?? undefined,
//       Active: p.active ?? undefined,
//       TwoFA: p.twoFA ?? undefined,
//       DoctorHeadID: p.doctorHeadID,
//       PolicyAcceptance: p.policyAcceptance
//     }
//   })
//    // ✅ EXPLICIT NULL HANDLING
//   if (p.policyAcceptance === null) {
//     params.PolicyAcceptance = null   // FORCE SEND NULL
//   } else if (p.policyAcceptance !== undefined) {
//     params.PolicyAcceptance = p.policyAcceptance // true/false
//   }

// }
export const getSignUpResolve = async (): Promise<SignUpResolve> => {
  const { data } = await axios.get<SignUpResolve>(API_URL + `/GetSignUpResolve`)
  return data || null
}
export const getDoctorProfile = async (
  documentID: string
): Promise<SignUpForm> => {
  const { data } = await axios.get<SignUpForm>(
    `Users/GetDoctorProfile?documentID=${documentID}`
  )
  return data || null
}
// export const getLoginReport = async (
//   pageNumber = 1,
//   pageSize = 10,
//   searchQuery = ''
// ): Promise<AxiosResponse<VwLoginReport[]>> => {
//   const response = await axios.get<VwLoginReport[]>(
//     API_URL +
//       `?pageNumber=${pageNumber}&pageSize=${pageSize}&SearchQuery=${searchQuery}`
//   )
//   return response || null
// }

export function getLoginReport(
  p: GetUsersParams
): Promise<AxiosResponse<VwLoginReport[]>> {
  //console.log(p)
  return axios.get<VwLoginReport[]>(API_URL, {
    params: {
      pageNumber: p.pageNumber ?? 1,
      pageSize: p.pageSize ?? 25,
      SearchQuery: p.searchQuery?.trim() || undefined,
      RoleId: p.roleId ?? undefined,
      Active: p.active ?? undefined,
      TwoFA: p.twoFA ?? undefined,
      roleName: p.roleName ?? undefined
    }
  })
}

export const needsADoctor = (): boolean | null => {
  if (localStorage.getItem('needsADoctor') == null) return false
  return localStorage.getItem('needsADoctor') == 'true' ? true : false
}
export const getSelectedDoctor = (): string | null => {
  return localStorage.getItem('selectedDoctor')
}
export const getMenu = (): Menu[] => {
  const json = JSON.parse(JSON.stringify(localStorage.getItem('currentUser')))
  return JSON.parse(json).menus
}
export const getUserRole = (): string => {
  const json = JSON.parse(JSON.stringify(localStorage.getItem('currentUser')))
  return JSON.parse(json).role
}
export const getUserRmtId = (): string => {
  const json = JSON.parse(JSON.stringify(localStorage.getItem('currentUser')))
  return JSON.parse(json).rmtUserId
}
export const getDoctorHeadId = (): string => {
  const json = JSON.parse(JSON.stringify(localStorage.getItem('currentUser')))
  return JSON.parse(json).doctorHeadId
}

export const getCurrentUser = (): CurrentUser => {
  const user =
    getUserRole() === Role.Doctor || Role.DoctorStaff
      ? localStorage.getItem('currentUser')
      : localStorage.getItem('currentDoctor')

  const json = JSON.parse(JSON.stringify(user))
  return JSON.parse(json)
}

export const getHeadDoctor = (): Doctor => {
  const user = getCurrentUser().headDoctor

  // console.log('aqui', user)
  // const json = JSON.parse(JSON.stringify(user))
  return user
}
export const getCurrentDoctor = (): string => {
  const json = JSON.parse(JSON.stringify(localStorage.getItem('currentDoctor')))
  return JSON.parse(json)
}
export const _change2FA = async (
  model: TwoFactorUser
): Promise<TwoFactorUser[]> => {
  const { data } = await axios.put<TwoFactorUser[]>(`Users/Update2FA`, model)
  return data
}
export const deleteUser = async (userId: number): Promise<string> => {
  const { data } = await axios.delete('Users/DeleteUser', {
    params: { id: userId }
  })
  return data
}
export const resendPassword = async (model: UserVM): Promise<string> => {
  const { data } = await axios.post('Users/ResendPassword', model)
  return data
}
// export const resendProfileConfirmation = async (
//   doctorId: string
// ): Promise<string> => {
//   const { data } = await axios.post('Users/ResendProfileConfirmation', doctorId)
//   console.log(data)
//   return data
// }

export const resendProfileConfirmation = async (
  doctorId: string
): Promise<string> => {
  // const obj = { isUnderMaintenance: true }
  const config = { headers: { 'Content-Type': 'application/json' } }
  const { data } = await axios.post(
    'Users/ResendProfileConfirmation',
    doctorId,
    config
  )
  return data
}
export const _toggleMaintenance = async (
  isUnderMaintenance: boolean
): Promise<boolean> => {
  // const obj = { isUnderMaintenance: true }
  const config = { headers: { 'Content-Type': 'application/json' } }
  await axios.post('Users/maintenance', isUnderMaintenance, config)
  return true
}

export const _toggleLock = async (userId: number): Promise<boolean | null> => {
  // const obj = { isLocked: true }
  //console.log(userId)
  const config = { headers: { 'Content-Type': 'application/json' } }
  await axios.post('Users/ToggleLock', userId, config)
  return true
}
export const _validatePassword = async (password: string): Promise<boolean> => {
  const config = { headers: { 'Content-Type': 'application/json' } }
  return (
    await axios.post('Users/ValidatePassword', JSON.stringify(password), config)
  ).data
}
export const getNotifications = async (
  userId: string
): Promise<AxiosResponse<Notification[]>> => {
  const response = await axios.get<Notification[]>(
    `Notifications?userId=${userId}`
  )
  return response || null
}

export const sendNotification = async (
  model: PostNotification
): Promise<AxiosResponse<NotificationResult>> => {
  const { data } = await axios.post('Notifications', model)
  return data
}

export const markAsRead = async (notificationId: number): Promise<boolean> => {
  const { data } = await axios.put(
    `Notifications/UpdateNotification/${notificationId}`
  )
  return data
}
export default {
  getMenu,
  getUserRole
}
